import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { PureComponent } from "react";
import { withGenericConfig } from "/contexts/generic-config-context";
import PhoneInputComponent from "react-phone-input-2";
import { componentStyles } from "./phone-input.scss";
import { commonInputStyles } from "../common-inputs.scss";
import { phoneInputStyles } from "./phone-input-component.scss";
class PhoneInput extends PureComponent {
    render() {
        const { inputData, errorState, onInputChange, onInputBlur, value, cloudfrontViewerCountry, id } = this.props;
        const { inputName, isRequired } = inputData;
        const { isValid } = errorState;
        const showRequiredError = !isValid && isRequired;
        const defaultCountry = cloudfrontViewerCountry && cloudfrontViewerCountry.toLowerCase() || "us";
        return /*#__PURE__*/ _jsxs("div", {
            id: id,
            className: `jsx-${componentStyles.__hash} jsx-${commonInputStyles.__hash} jsx-${phoneInputStyles.__hash}` + " " + "hp-input hp-phone-input",
            children: [
                /*#__PURE__*/ _jsx(PhoneInputComponent, {
                    country: defaultCountry,
                    value: value,
                    onChange: (phone)=>onInputChange({
                            target: {
                                name: inputName,
                                value: phone
                            }
                        }),
                    onBlur: ()=>onInputBlur({
                            target: {
                                name: inputName,
                                value
                            }
                        }),
                    name: inputName,
                    enableSearch: true,
                    disableSearchIcon: true,
                    inputClass: showRequiredError ? "input-required" : "",
                    specialLabel: ""
                }),
                /*#__PURE__*/ _jsx(_JSXStyle, {
                    id: phoneInputStyles.__hash,
                    children: phoneInputStyles
                }),
                /*#__PURE__*/ _jsx(_JSXStyle, {
                    id: commonInputStyles.__hash,
                    children: commonInputStyles
                }),
                /*#__PURE__*/ _jsx(_JSXStyle, {
                    id: componentStyles.__hash,
                    children: componentStyles
                })
            ]
        });
    }
    constructor(props){
        super(props);
    }
}
PhoneInput.defaultProps = {};
export default withGenericConfig(PhoneInput);
